import React, {Fragment} from 'react';
import {Text, View, StyleSheet } from '@react-pdf/renderer';
import moment from "moment";

const styles = StyleSheet.create({
    headerContainer: {
         padding:10,
        borderBottomColor: '#C8C8C8',
        borderBottomWidth: 1,
    },
    billTo: {
        color: '#000',
        fontSize: 10,
        marginTop:5
    },
    cancellationpolicy: {
      color: '#000',
      fontSize: 10,
      fontWeight:100,
  },
  offerName:{
    color: '#000',
    fontSize: 10,
    backgroundColor:'#bfe4e0',
    padding:5,
  }
  });


  let getDateModal = (data, selectedDate) => {
    let DataNew = "";
    const selectActivityDay = selectedDate;

    if (data[0].cancellation_penalty_id == 1) {
      const date = new Date(selectActivityDay);
      DataNew =
        "Free Cancellation (100% refund) if you cancel this booking on or before start of experience (tour, event, attraction, activity). ";
    } else if (data[0].cancellation_penalty_id == 3) {
      DataNew =
        "Minimum " +
        data[0].cancellation_value +
        "% cancellation charges applicable";
    }
    return DataNew;
  };

  let CancellationModal = (data, selectedDate) => {
    let DataNew = "";
    let Value = "";
    let EuroIcon = "";
    let PerIcon = "";
    let ContentData = "";
    return (
      <Text>
        {" "}
        {data
          .slice(0)
          .reverse()
          .map((i, index) => {
            //const date = new Date();
            const selectActivityDay = selectedDate;
            const date = new Date(selectActivityDay);
            if (i.day_before_arrival == 1 || i.day_before_arrival == 2) {
              date.setDate(date.getDate() - i.day_before_arrival);
              DataNew = moment(date).format("Do MMM YYYY");
            }
            {
              date.setDate(date.getDate() - (i.day_before_arrival - 2));
              // DataNew = moment(date).format("Do MMM YYYY");
              DataNew =
                "If cancelled or modified " +
                parseInt(i.day_before_arrival - 2) +
                " days before date of experience (tour, event, attraction, activity).";
            }

            if (i.penalty == "No Penalty") {
              Value = 0;
              EuroIcon = "";
              PerIcon = "";
            } else if (i.penalty == "Full Amount") {
              Value = "";
              EuroIcon = "";
              PerIcon = "Full booking amount will be charged";
            } else if (i.penalty == "Percentage") {
              Value = i.cancellation_value;
              EuroIcon = "";
              PerIcon = "% of booking amount will be charged ";
            } else if (i.penalty == "Nights") {
              Value = i.cancellation_value;
              EuroIcon = EuroIcon = <span>€</span>;
              PerIcon = " amount will be charged.";
            } else if (i.penalty == "Fixed Amount") {
              Value = i.cancellation_value;
              EuroIcon = <span>€</span>;
              PerIcon = " amount will be charged.";
            }

            if (i.day_before_arrival == 1) {
              DataNew = "In case of no show";
              //ContentData = "In case of "
            }

            //   if (id == i.rate_plan_id) {
            return (
              <Text>
                <Text style={styles.cancellationpolicy}>
                  {index == 0 ? "" : ""} &#x202A;{DataNew}&#x202C;
                </Text>
                <Text style={styles.cancellationpolicy}>
                  {EuroIcon} {Value}
                  {PerIcon}
                </Text>
              </Text>
            );
            
          })}
      </Text>
    );
  };

  const CancellationExperience = ({invoice}) => {

    //var selectedDate = invoice.dateselected;
  //  const rowsCancel =   invoice?.cancellationpolicy?.cancellation_policy.map(item =>{
  //  return item[0].cancellation_penalty_id == 1 ?(<Text style={styles.billTo}>{getDateModal(item, selectedDate)} <br/></Text>):(<Text style={styles.billTo}>{CancellationModal(item, selectedDate)} <br/></Text>)
  //  }
  //  )
   return (<View style={styles.headerContainer}>{invoice?.OfferName?.offerName &&(<Text style={styles.offerName}>{invoice?.OfferName?.offerName}</Text>)}{invoice.firstcancellationdate !="" &&(<Text style={styles.billTo}><b>Cancellation Policy: </b>Free Cancellation before {moment(
    invoice.firstcancellationdate
  ).format("D MMM Y")}</Text>)}</View>)
  }

  export default CancellationExperience